"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Sidebar_component_1 = require("./Sidebar.component");
exports.Sidebar = Sidebar_component_1.Sidebar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Qcm9wb3NhbEZvcm0vcGFydHMvU2lkZWJhci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlEQUEyQztBQUFuQyxzQ0FBQSxPQUFPLENBQUEifQ==